import { create } from 'zustand'

export interface TransactionsState {
  pagination: {
    page: number
    limit: number
    setPage: (page: number) => void
    setLimit: (limit: number) => void
  }
  sorting: {
    sorting: { id: string; desc: boolean }[]
    setSorting: (sorting: { id: string; desc: boolean }[]) => void
  }
  dialog: {
    isOpen: boolean
    setOpen: (isOpen: boolean) => void
  }
}

export const useTransactionsStore = create<TransactionsState>((set) => ({
  pagination: {
    page: 1,
    limit: 10,
    setPage: (page: number) =>
      set((state) => ({ pagination: { ...state.pagination, page } })),
    setLimit: (limit: number) =>
      set((state) => ({ pagination: { ...state.pagination, limit } })),
  },
  sorting: {
    sorting: [],
    setSorting: (sorting) =>
      set((state) => ({ sorting: { ...state.sorting, sorting } })),
  },
  dialog: {
    isOpen: false,
    setOpen: (isOpen: boolean) =>
      set((state) => ({ dialog: { ...state.dialog, isOpen } })),
  },
}))
